import React, { useEffect } from 'react';
import { Link } from 'wouter';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useToast } from '../hooks/use-toast';

export default function SubscriptionSuccessPage() {
  const { refreshSubscriptions } = useSubscription();
  const { toast } = useToast();

  useEffect(() => {
    // Refresh subscription data
    refreshSubscriptions();
    
    toast({
      title: 'Welcome to your new plan!',
      description: 'Your subscription has been successfully activated.',
    });
  }, [refreshSubscriptions, toast]);

  return (
    <div className="min-h-screen bg-app-theme flex items-center justify-center">
      <div className="max-w-md mx-auto text-center">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Your subscription has been activated and you now have access to all premium features.
          </p>
          
          <div className="space-y-4">
            <Link
              href="/dashboard"
              className="block w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors"
            >
              Go to Dashboard
            </Link>
            
            <Link
              href="/settings"
              className="block w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
            >
              Manage Subscription
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}













